/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал регистрации в системе RFID-ключей.
 * Только зарегистрированные RFID-ключи доступны для активации пользователям
 */

/**
 * Сервис реестра ключей
 */
export class RecordServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения записи.
   * Нельзя отвязать ключ, который привязал кто-то другой.
   * Разрешения: rfidregistry:record:save.
   * Метод доступен для: Token: seller, employee, application, service, device_admin, ltp_first, admin, master, owner, mrf, bti, manager, external_seller. При наличии разрешений
   */
  PostRecord = (req: PostRecordRequestDto, init?: RequestInit): Promise<PostRecordResponseDto> => {
    return fm.request<PostRecordRequestDto, PostRecordResponseDto>(`${this.host}/rfidregistry/api/v1/record`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения записи.
   * Разрешения: rfidregistry:record:card.
   * Метод доступен для: Token: seller, employee, application, service, device_admin, ltp_first, admin, master, owner, mrf, bti, manager, external_seller. При наличии разрешений
   */
  GetRecord = (req: GetRecordRequestDto, init?: RequestInit): Promise<GetRecordResponseDto> => {
    return fm.request<GetRecordRequestDto, GetRecordResponseDto>(`${this.host}/rfidregistry/api/v1/record/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка записей.
   * Разрешения: rfidregistry:record:list.
   * Метод доступен для: Token: seller, employee, application, service, device_admin, ltp_first, admin, master, owner, mrf, bti, manager, external_seller. При наличии разрешений
   */
  GetRecordList = (req?: GetRecordListRequestDto, init?: RequestInit): Promise<GetRecordListResponseDto[]> => {
    return fm.list<GetRecordListRequestDto, GetRecordListResponseDto>(`${this.host}/rfidregistry/api/v1/record/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества записей.
   * Разрешения: rfidregistry:record:list.
   * Метод доступен для: Token: seller, employee, application, service, device_admin, ltp_first, admin, master, owner, mrf, bti, manager, external_seller. При наличии разрешений
   */
  GetRecordCount = (req?: GetRecordCountRequestDto, init?: RequestInit): Promise<GetRecordCountResponseDto> => {
    return fm.request<GetRecordCountRequestDto, GetRecordCountResponseDto>(`${this.host}/rfidregistry/api/v1/record/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления записи.
   * Можно удалять только свои записи.
   * Нельзя удалить ключ, если его использует кто-то другой.
   * Разрешения: rfidregistry:record:remove.
   * Метод доступен для: Token: seller, employee, application, service, device_admin, ltp_first, admin, master, owner, mrf, bti, manager, external_seller. При наличии разрешений
   */
  DeleteRecord = (req: DeleteRecordRequestDto, init?: RequestInit): Promise<DeleteRecordResponseDto> => {
    return fm.request<DeleteRecordRequestDto, DeleteRecordResponseDto>(`${this.host}/rfidregistry/api/v1/record/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов шифрования ключа.
 */
export enum RecordEncryptionType {
  /**
   * Значение не указано
   */
  ENCRYPTION_TYPE_UNKNOWN = "ENCRYPTION_TYPE_UNKNOWN",
  /**
   * Без шифрования
   */
  SL0 = "SL0",
  /**
   * С шифрованием, копируемый
   */
  SL1 = "SL1",
  /**
   * С шифрованием, не копируемый
   */
  SL3 = "SL3",
}
/**
 * Справочник типов шифрования ключа.
 */
export type RecordEncryptionTypeResponseEnum = keyof typeof RecordEncryptionType
/**
 * Справочник типов шифрования ключа.
 */
export type RecordEncryptionTypeRequestEnum = Exclude<RecordEncryptionTypeResponseEnum, "ENCRYPTION_TYPE_UNKNOWN">;

/**
 * Справочник методов идентификации.
 */
export enum RecordIdentificationMethodType {
  /**
   * Значение не указано
   */
  IDENTIFICATION_METHOD_TYPE_UNKNOWN = "IDENTIFICATION_METHOD_TYPE_UNKNOWN",
  /**
   * Значение Mifare
   */
  MIFARE = "MIFARE",
  /**
   * Значение Bluetooth low energy
   */
  BLE = "BLE",
  /**
   * Значение Ultra high frequency
   */
  UHF = "UHF",
  /**
   * Значение em-marine
   */
  EM_MARINE = "EM_MARINE",
}
/**
 * Справочник методов идентификации.
 */
export type RecordIdentificationMethodTypeResponseEnum = keyof typeof RecordIdentificationMethodType
/**
 * Справочник методов идентификации.
 */
export type RecordIdentificationMethodTypeRequestEnum = Exclude<RecordIdentificationMethodTypeResponseEnum, "IDENTIFICATION_METHOD_TYPE_UNKNOWN">;

/**
 * Справочник типов ключей.
 */
export enum RecordRfidType {
  /**
   * Значение не указано
   */
  RFID_TYPE_UNKNOWN = "RFID_TYPE_UNKNOWN",
  /**
   * Брелок
   */
  FOB = "FOB",
  /**
   * Карта
   */
  CARD = "CARD",
  /**
   * Браслет
   */
  BAND = "BAND",
  /**
   * Стикер
   */
  STICKER = "STICKER",
  /**
   * Активная метка
   */
  ACTIVE_TAG = "ACTIVE_TAG",
}
/**
 * Справочник типов ключей.
 */
export type RecordRfidTypeResponseEnum = keyof typeof RecordRfidType
/**
 * Справочник типов ключей.
 */
export type RecordRfidTypeRequestEnum = Exclude<RecordRfidTypeResponseEnum, "RFID_TYPE_UNKNOWN">;

/**
 * Справочник типов статусов ключа.
 */
export enum RecordStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Новый
   */
  NEW = "NEW",
  /**
   * Отгружен
   */
  SHIPPED = "SHIPPED",
  /**
   * Брак
   */
  DEFECT = "DEFECT",
  /**
   * Использован
   */
  IN_USE = "IN_USE",
}
/**
 * Справочник типов статусов ключа.
 */
export type RecordStatusTypeResponseEnum = keyof typeof RecordStatusType
/**
 * Справочник типов статусов ключа.
 */
export type RecordStatusTypeRequestEnum = Exclude<RecordStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum RecordPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type RecordPagingDirectionTypeResponseEnum = keyof typeof RecordPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type RecordPagingDirectionTypeRequestEnum = Exclude<RecordPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum RecordPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По дате перевода в статус new (дате создания)
   */
  NEW_AT = "NEW_AT",
  /**
   * По времени изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * По времени заказа
   */
  ORDER_AT = "ORDER_AT",
  /**
   * По номеру заказа
   */
  ORDER_NUMBER = "ORDER_NUMBER",
  /**
   * По рангу для поиска по тексту.
   * Применяется когда передано поле для поиска по тексту.
   * В случае если текстовое поле не передано, применяется значение по умолчанию
   */
  RANK = "RANK",
}
/**
 * Справочник типов значений сортировки.
 */
export type RecordPagingOrderByTypeResponseEnum = keyof typeof RecordPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type RecordPagingOrderByTypeRequestEnum = Exclude<RecordPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос удаления записи из реестра.
 * Можно удалить только свои записи
 */
export type DeleteRecordRequestDto = {
  /**
   * Идентификатор записи.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления записи из реестра
 */
export type DeleteRecordResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteRecordResponseErrorDto
}>
/**
 * Ошибка удаления записи
 */
export type DeleteRecordResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка удаления записи
 */
export type DeleteRecordResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения количества записей
 */
export type GetRecordCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: RecordFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества записей
 */
export type GetRecordCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего записей
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetRecordCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества записей
 */
export type GetRecordCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации записей
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества записей
 */
export type GetRecordCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации записей
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения списка
 */
export type GetRecordListRequestDto = {
  /**
   * Фильтр
   */
  filter?: RecordFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: RecordPagingRequestDto
}>
/**
 * Ответ на запрос получения списка записей
 */
export type GetRecordListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Запись
   */
  readonly data: RecordResponseDto
  /**
   * Ошибка
   */
  readonly error: GetRecordListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка записей
 */
export type GetRecordListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации записей
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка записей
 */
export type GetRecordListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации записей
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения записи
 */
export type GetRecordRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения записи
 */
export type GetRecordResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Запись
   */
  readonly data: RecordResponseDto
}>
/**
 * Запрос сохранения записи
 */
export type PostRecordRequestDto = {
  /**
   * Запись
   */
  data: RecordRequestDto
}
/**
 * Ответ на запрос сохранения записи
 */
export type PostRecordResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Запись
   */
  readonly data: RecordResponseDto
  /**
   * Ошибка
   */
  readonly error: PostRecordResponseErrorDto
}>
/**
 * Ошибка запроса сохранения записи
 */
export type PostRecordResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка сохранения записи
   */
  readonly saving: RecordSavingErrorRequestDto
}>
/**
 * Ошибка запроса сохранения записи
 */
export type PostRecordResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка сохранения записи
   */
  readonly saving: RecordSavingErrorResponseDto
}>
/**
 * Запись.
 * # Описание модели
 */
export type RecordRequestDto = {
  /**
   * Идентификатор.
   * Если не передан создаётся сервером.
   * # Тип: Guid
   */
  id?: string
  /**
   * Тип ключа
   */
  rfidType: RecordRfidTypeRequestEnum
  /**
   * Тип шифрования ключа.
   * Максимально поддерживаемый ключом тип шифрования
   */
  encryptionType: RecordEncryptionTypeRequestEnum
  /**
   * Номер ключа.
   * Указывается при создании.
   * # Диапазон: 1..14
   */
  uid: string
  /**
   * Тип статуса ключа
   */
  statusType: RecordStatusTypeRequestEnum
  /**
   * Идентификатор привязанного ключа.
   * Заполняется при переводе в статус \"Использован\".
   * # Диапазон: 0..16
   */
  inUseRfidId?: string | null
  /**
   * Содержимое ячеек ключа
   */
  dataCells?: RecordDataCellRequestDto[]
  /**
   * Номер коробки.
   * # Диапазон: 1..2147483647
   */
  packageInfoBox?: number
  /**
   * Номер места в коробке.
   * # Диапазон: 1..2147483647
   */
  packageInfoPlace?: number
  /**
   * Конфигурации шифрования ключа
   */
  aesKeyConfigurations?: RecordAesKeyConfigurationRequestDto[]
  /**
   * Контрольные суммы.
   * Нужны для ключей SL1 и SL3
   */
  trailers?: RecordTrailerRequestDto[]
  /**
   * Номер заказа.
   * # Диапазон: 0..256
   */
  orderNumber: string
  /**
   * Дата заказа.
   * # Тип: DateTime
   */
  orderAt: string
  /**
   * Производитель.
   * # Диапазон: 3..100
   */
  vendorName?: string | null
  /**
   * Метод идентификации
   */
  identificationMethodType?: RecordIdentificationMethodTypeRequestEnum | "IDENTIFICATION_METHOD_TYPE_UNKNOWN"
}
/**
 * Запись.
 * # Описание модели
 */
export type RecordResponseDto = {
  /**
   * Идентификатор.
   * Если не передан создаётся сервером.
   * # Тип: Guid
   */
  id: string
  /**
   * Тип ключа
   */
  rfidType: RecordRfidTypeResponseEnum
  /**
   * Тип шифрования ключа.
   * Максимально поддерживаемый ключом тип шифрования
   */
  encryptionType: RecordEncryptionTypeResponseEnum
  /**
   * Номер ключа.
   * Указывается при создании.
   * # Диапазон: 1..14
   */
  uid: string
  /**
   * Тип статуса ключа
   */
  statusType: RecordStatusTypeResponseEnum
  /**
   * Дата перевода в статус \"Новый\".
   * # Тип: DateTime
   */
  readonly newAt: string | null
  /**
   * Дата перевода в статус \"Отгружен\".
   * # Тип: DateTime
   */
  readonly shippedAt: string | null
  /**
   * Дата перевода в статус \"Брак\".
   * # Тип: DateTime
   */
  readonly defectAt: string | null
  /**
   * Дата перевода в статус \"Использован\".
   * # Тип: DateTime
   */
  readonly inUseAt: string | null
  /**
   * Идентификатор привязанного ключа.
   * Заполняется при переводе в статус \"Использован\".
   * # Диапазон: 0..16
   */
  inUseRfidId: string | null
  /**
   * Содержимое ячеек ключа
   */
  dataCells: RecordDataCellResponseDto[]
  /**
   * Идентификатор владельца.
   * Заполняется сервером.
   * # Диапазон: 0..255
   */
  readonly resourceOwnerId: string
  /**
   * Номер коробки.
   * # Диапазон: 1..2147483647
   */
  packageInfoBox: number
  /**
   * Номер места в коробке.
   * # Диапазон: 1..2147483647
   */
  packageInfoPlace: number
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  readonly changedAt: string
  /**
   * Конфигурации шифрования ключа
   */
  aesKeyConfigurations: RecordAesKeyConfigurationResponseDto[]
  /**
   * Контрольные суммы.
   * Нужны для ключей SL1 и SL3
   */
  trailers: RecordTrailerResponseDto[]
  /**
   * Номер заказа.
   * # Диапазон: 0..256
   */
  orderNumber: string
  /**
   * Дата заказа.
   * # Тип: DateTime
   */
  orderAt: string
  /**
   * Владелец привязанного ключа.
   * Заполняется сервером, значение берётся из токена при использовании ключа.
   * # Диапазон: 0..255
   */
  readonly inUseResourceOwnerId: string | null
  /**
   * Признак, удалена ли запись
   */
  readonly isDeleted: boolean
  /**
   * Дата удаления.
   * # Тип: DateTime
   */
  readonly deletedAt: string | null
  /**
   * Производитель.
   * # Диапазон: 3..100
   */
  vendorName: string | null
  /**
   * Метод идентификации
   */
  identificationMethodType: RecordIdentificationMethodTypeResponseEnum
}
/**
 * Конфигурация шифрования ключа
 */
export type RecordAesKeyConfigurationRequestDto = {
  /**
   * Адрес.
   * # Паттерн: /^[A-Za-z0-9=]+$/
   */
  address: string
  /**
   * Данные.
   * # Паттерн: /^[A-Za-z0-9=]+$/
   */
  data: string
}
/**
 * Конфигурация шифрования ключа
 */
export type RecordAesKeyConfigurationResponseDto = {
  /**
   * Адрес.
   * # Паттерн: /^[A-Za-z0-9=]+$/
   */
  address: string
  /**
   * Данные.
   * # Паттерн: /^[A-Za-z0-9=]+$/
   */
  data: string
}
/**
 * Содержимое ячейки ключа
 */
export type RecordDataCellRequestDto = {
  /**
   * Сектор.
   * # Диапазон: 0..127
   */
  section: number
  /**
   * Блок.
   * # Диапазон: 0..127
   */
  block: number
  /**
   * Данные.
   * # Паттерн: /^[A-Za-z0-9=]+$/
   */
  data: string
}
/**
 * Содержимое ячейки ключа
 */
export type RecordDataCellResponseDto = {
  /**
   * Сектор.
   * # Диапазон: 0..127
   */
  section: number
  /**
   * Блок.
   * # Диапазон: 0..127
   */
  block: number
  /**
   * Данные.
   * # Паттерн: /^[A-Za-z0-9=]+$/
   */
  data: string
}
/**
 * Ошибка сохранения записи.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type RecordSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Перевод статуса запрещён
   */
  readonly statusTypeRestricted: RecordSavingErrorStatusTypeRestrictedRequestDto
  /**
   * Запись уже существует
   */
  readonly uidExist: RecordSavingErrorUidExistRequestDto
  /**
   * Вы не владелец
   */
  readonly ownedByAnotherUser: RecordSavingErrorOwnedByAnotherUserRequestDto
  /**
   * Ключ уже использован
   */
  readonly alreadyLinked: RecordSavingErrorAlreadyLinkedRequestDto
  /**
   * Конфликт версий
   */
  readonly conflict: RecordSavingErrorConflictRequestDto
}>
/**
 * Ошибка сохранения записи.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type RecordSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Перевод статуса запрещён
   */
  readonly statusTypeRestricted: RecordSavingErrorStatusTypeRestrictedResponseDto
  /**
   * Запись уже существует
   */
  readonly uidExist: RecordSavingErrorUidExistResponseDto
  /**
   * Вы не владелец
   */
  readonly ownedByAnotherUser: RecordSavingErrorOwnedByAnotherUserResponseDto
  /**
   * Ключ уже использован
   */
  readonly alreadyLinked: RecordSavingErrorAlreadyLinkedResponseDto
  /**
   * Конфликт версий
   */
  readonly conflict: RecordSavingErrorConflictResponseDto
}>
/**
 * Причины:
 * - Такой ключ уже привязан к другой записи
 */
export type RecordSavingErrorAlreadyLinkedRequestDto = {
}
/**
 * Причины:
 * - Такой ключ уже привязан к другой записи
 */
export type RecordSavingErrorAlreadyLinkedResponseDto = {
}
/**
 * Причины:
 * - В базе хранится более новая версия записи, значения changed_at отличаются
 */
export type RecordSavingErrorConflictRequestDto = {
}
/**
 * Причины:
 * - В базе хранится более новая версия записи, значения changed_at отличаются
 */
export type RecordSavingErrorConflictResponseDto = {
}
/**
 * Причины:
 * - Запись принадлежит другому пользователю
 */
export type RecordSavingErrorOwnedByAnotherUserRequestDto = {
}
/**
 * Причины:
 * - Запись принадлежит другому пользователю
 */
export type RecordSavingErrorOwnedByAnotherUserResponseDto = {
}
/**
 * Причины:
 * - Недопустимый перевод статуса.
 * - Не переданы обязательные поля https://openapi-key.deploy.rtkit.dev/keyapis_rfidregistry_v1/#таблица-обязательности-передачи-полей-в-request
 */
export type RecordSavingErrorStatusTypeRestrictedRequestDto = {
}
/**
 * Причины:
 * - Недопустимый перевод статуса.
 * - Не переданы обязательные поля https://openapi-key.deploy.rtkit.dev/keyapis_rfidregistry_v1/#таблица-обязательности-передачи-полей-в-request
 */
export type RecordSavingErrorStatusTypeRestrictedResponseDto = {
}
/**
 * Причины:
 * - Ключ уже существует
 */
export type RecordSavingErrorUidExistRequestDto = {
}
/**
 * Причины:
 * - Ключ уже существует
 */
export type RecordSavingErrorUidExistResponseDto = {
}
/**
 * Контрольная сумма
 */
export type RecordTrailerRequestDto = {
  /**
   * Сектор.
   * # Диапазон: 0..15
   */
  sector: number
  /**
   * Ключ А.
   * # Диапазон: 1..256
   */
  keyA: string
  /**
   * Ключ Б.
   * # Диапазон: 1..256
   */
  keyB: string
  /**
   * Маска доступа.
   * # Диапазон: 1..512
   */
  accessMask: string
}
/**
 * Контрольная сумма
 */
export type RecordTrailerResponseDto = {
  /**
   * Сектор.
   * # Диапазон: 0..15
   */
  sector: number
  /**
   * Ключ А.
   * # Диапазон: 1..256
   */
  keyA: string
  /**
   * Ключ Б.
   * # Диапазон: 1..256
   */
  keyB: string
  /**
   * Маска доступа.
   * # Диапазон: 1..512
   */
  accessMask: string
}
/**
 * Фильтр записей
 */
export type RecordFilterRequestDto = {
  /**
   * По типам ключей
   */
  rfidTypes?: RecordRfidTypeResponseEnum[]
  /**
   * По типам шифрования
   */
  encryptionTypes?: RecordEncryptionTypeResponseEnum[]
  /**
   * По номерам ключей
   */
  uids?: string[]
  /**
   * По типам статуса
   */
  statusTypes?: RecordStatusTypeResponseEnum[]
  /**
   * По номерам привязанных ключей
   */
  inUseRfidIds?: string[]
  /**
   * По владельцам
   */
  resourceOwnerIds?: string[]
  /**
   * По номерам заказа
   */
  orderNumbers?: string[]
  /**
   * По владельцам привязанных ключей
   */
  inUseResourceOwnerIds?: string[]
  /**
   * По удалённым записям.
   * По умолчанию: false
   */
  isDeleted?: boolean | null
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Номер заказа;
   * # - Производитель
   */
  text?: string | null
  /**
   * Дата отгрузки от
   */
  startShippedAt?: string | null
  /**
   * Дата отгрузки до
   */
  endShippedAt?: string | null
  /**
   * По номеру коробки
   */
  packageInfoBoxes?: number[]
  /**
   * По номеру места в коробке
   */
  packageInfoPlaces?: number[]
  /**
   * По методу идентификации
   */
  identificationMethodTypes?: RecordIdentificationMethodTypeResponseEnum[]
}
/**
 * Фильтр записей
 */
export type RecordFilterResponseDto = {
  /**
   * По типам ключей
   */
  rfidTypes: RecordRfidTypeResponseEnum[]
  /**
   * По типам шифрования
   */
  encryptionTypes: RecordEncryptionTypeResponseEnum[]
  /**
   * По номерам ключей
   */
  uids: string[]
  /**
   * По типам статуса
   */
  statusTypes: RecordStatusTypeResponseEnum[]
  /**
   * По номерам привязанных ключей
   */
  inUseRfidIds: string[]
  /**
   * По владельцам
   */
  resourceOwnerIds: string[]
  /**
   * По номерам заказа
   */
  orderNumbers: string[]
  /**
   * По владельцам привязанных ключей
   */
  inUseResourceOwnerIds: string[]
  /**
   * По удалённым записям.
   * По умолчанию: false
   */
  isDeleted: boolean | null
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Номер заказа;
   * # - Производитель
   */
  text: string | null
  /**
   * Дата отгрузки от
   */
  startShippedAt: string | null
  /**
   * Дата отгрузки до
   */
  endShippedAt: string | null
  /**
   * По номеру коробки
   */
  packageInfoBoxes: number[]
  /**
   * По номеру места в коробке
   */
  packageInfoPlaces: number[]
  /**
   * По методу идентификации
   */
  identificationMethodTypes: RecordIdentificationMethodTypeResponseEnum[]
}
/**
 * Пагинация записей
 */
export type RecordPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: NEW_AT
   */
  orderByType?: RecordPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: RecordPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Пагинация записей
 */
export type RecordPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: NEW_AT
   */
  orderByType: RecordPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: RecordPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления записи из реестра.
   * Можно удалить только свои записи
   */
  "DeleteRecordRequest": {
    "kind": "class",
    "text": "Запрос удаления записи из реестра.\nМожно удалить только свои записи",
    "fields": {
      /**
       * Идентификатор записи.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор записи.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления записи из реестра
   */
  "DeleteRecordResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления записи из реестра",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteRecordResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка удаления записи
   */
  "DeleteRecordResponse.Error": {
    "kind": "class",
    "text": "Ошибка удаления записи",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества записей
   */
  "GetRecordCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества записей",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "RecordFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества записей
   */
  "GetRecordCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества записей",
    "fields": {
      /**
       * Всего записей
       */
      "data": {
        "type": "int32",
        "text": "Всего записей",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetRecordCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества записей
   */
  "GetRecordCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества записей",
    "fields": {
      /**
       * Ошибка фильтрации записей
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка фильтрации записей",
      },
    },
  },
  /**
   * Запрос получения списка
   */
  "GetRecordListRequest": {
    "kind": "class",
    "text": "Запрос получения списка",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "RecordFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "RecordPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка записей
   */
  "GetRecordListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка записей",
    "fields": {
      /**
       * Запись
       */
      "data": {
        "type": "Record",
        "text": "Запись",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetRecordListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка записей
   */
  "GetRecordListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка записей",
    "fields": {
      /**
       * Ошибка фильтрации записей
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка фильтрации записей",
      },
    },
  },
  /**
   * Запрос получения записи
   */
  "GetRecordRequest": {
    "kind": "class",
    "text": "Запрос получения записи",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения записи
   */
  "GetRecordResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения записи",
    "fields": {
      /**
       * Запись
       */
      "data": {
        "type": "Record",
        "text": "Запись",
      },
    },
  },
  /**
   * Запрос сохранения записи
   */
  "PostRecordRequest": {
    "kind": "class",
    "text": "Запрос сохранения записи",
    "fields": {
      /**
       * Запись
       */
      "data": {
        "type": "Record",
        "text": "Запись",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения записи
   */
  "PostRecordResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения записи",
    "fields": {
      /**
       * Запись
       */
      "data": {
        "type": "Record",
        "text": "Запись",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostRecordResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения записи
   */
  "PostRecordResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения записи",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения записи
       */
      "saving": {
        "type": "Record.SavingError",
        "text": "Ошибка сохранения записи",
      },
    },
  },
  /**
   * Запись.
   * # Описание модели
   */
  "Record": {
    "kind": "class",
    "text": "Запись.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * Если не передан создаётся сервером.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\nЕсли не передан создаётся сервером.\n# Тип: Guid",
      },
      /**
       * Тип ключа
       */
      "rfidType": {
        "type": "Record.RfidType",
        "text": "Тип ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип шифрования ключа.
       * Максимально поддерживаемый ключом тип шифрования
       */
      "encryptionType": {
        "type": "Record.EncryptionType",
        "text": "Тип шифрования ключа.\nМаксимально поддерживаемый ключом тип шифрования",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер ключа.
       * Указывается при создании.
       * # Диапазон: 1..14
       */
      "uid": {
        "type": "string",
        "text": "Номер ключа.\nУказывается при создании.\n# Диапазон: 1..14",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 14,
            "message": "Значение не входит в допустимый диапазон. Максимум: 14"
          },
        }
      },
      /**
       * Тип статуса ключа
       */
      "statusType": {
        "type": "Record.StatusType",
        "text": "Тип статуса ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата перевода в статус \"Новый\".
       * # Тип: DateTime
       */
      "newAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата перевода в статус \"Новый\".\n# Тип: DateTime",
      },
      /**
       * Дата перевода в статус \"Отгружен\".
       * # Тип: DateTime
       */
      "shippedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата перевода в статус \"Отгружен\".\n# Тип: DateTime",
      },
      /**
       * Дата перевода в статус \"Брак\".
       * # Тип: DateTime
       */
      "defectAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата перевода в статус \"Брак\".\n# Тип: DateTime",
      },
      /**
       * Дата перевода в статус \"Использован\".
       * # Тип: DateTime
       */
      "inUseAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата перевода в статус \"Использован\".\n# Тип: DateTime",
      },
      /**
       * Идентификатор привязанного ключа.
       * Заполняется при переводе в статус \"Использован\".
       * # Диапазон: 0..16
       */
      "inUseRfidId": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор привязанного ключа.\nЗаполняется при переводе в статус \"Использован\".\n# Диапазон: 0..16",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 16,
            "message": "Значение не входит в допустимый диапазон. Максимум: 16"
          },
        }
      },
      /**
       * Содержимое ячеек ключа
       */
      "dataCells": {
        "type": "Record.DataCell",
        "text": "Содержимое ячеек ключа",
      },
      /**
       * Идентификатор владельца.
       * Заполняется сервером.
       * # Диапазон: 0..255
       */
      "resourceOwnerId": {
        "type": "string",
        "text": "Идентификатор владельца.\nЗаполняется сервером.\n# Диапазон: 0..255",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 255,
            "message": "Значение не входит в допустимый диапазон. Максимум: 255"
          },
        }
      },
      /**
       * Номер коробки.
       * # Диапазон: 1..2147483647
       */
      "packageInfoBox": {
        "type": "int32",
        "text": "Номер коробки.\n# Диапазон: 1..2147483647",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Номер места в коробке.
       * # Диапазон: 1..2147483647
       */
      "packageInfoPlace": {
        "type": "int32",
        "text": "Номер места в коробке.\n# Диапазон: 1..2147483647",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
      /**
       * Конфигурации шифрования ключа
       */
      "aesKeyConfigurations": {
        "type": "Record.AesKeyConfiguration",
        "text": "Конфигурации шифрования ключа",
      },
      /**
       * Контрольные суммы.
       * Нужны для ключей SL1 и SL3
       */
      "trailers": {
        "type": "Record.Trailer",
        "text": "Контрольные суммы.\nНужны для ключей SL1 и SL3",
      },
      /**
       * Номер заказа.
       * # Диапазон: 0..256
       */
      "orderNumber": {
        "type": "string",
        "text": "Номер заказа.\n# Диапазон: 0..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Дата заказа.
       * # Тип: DateTime
       */
      "orderAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата заказа.\n# Тип: DateTime",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Владелец привязанного ключа.
       * Заполняется сервером, значение берётся из токена при использовании ключа.
       * # Диапазон: 0..255
       */
      "inUseResourceOwnerId": {
        "type": "google.protobuf.StringValue",
        "text": "Владелец привязанного ключа.\nЗаполняется сервером, значение берётся из токена при использовании ключа.\n# Диапазон: 0..255",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 255,
            "message": "Значение не входит в допустимый диапазон. Максимум: 255"
          },
        }
      },
      /**
       * Признак, удалена ли запись
       */
      "isDeleted": {
        "type": "bool",
        "text": "Признак, удалена ли запись",
      },
      /**
       * Дата удаления.
       * # Тип: DateTime
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления.\n# Тип: DateTime",
      },
      /**
       * Производитель.
       * # Диапазон: 3..100
       */
      "vendorName": {
        "type": "google.protobuf.StringValue",
        "text": "Производитель.\n# Диапазон: 3..100",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Метод идентификации
       */
      "identificationMethodType": {
        "type": "Record.IdentificationMethodType",
        "text": "Метод идентификации",
      },
    },
  },
  /**
   * Конфигурация шифрования ключа
   */
  "Record.AesKeyConfiguration": {
    "kind": "class",
    "text": "Конфигурация шифрования ключа",
    "fields": {
      /**
       * Адрес.
       * # Паттерн: /^[A-Za-z0-9=]+$/
       */
      "address": {
        "type": "string",
        "text": "Адрес.\n# Паттерн: /^[A-Za-z0-9=]+$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^[A-Za-z0-9=]+$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Za-z0-9=]+$/"
          }
        }
      },
      /**
       * Данные.
       * # Паттерн: /^[A-Za-z0-9=]+$/
       */
      "data": {
        "type": "string",
        "text": "Данные.\n# Паттерн: /^[A-Za-z0-9=]+$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^[A-Za-z0-9=]+$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Za-z0-9=]+$/"
          }
        }
      },
    },
  },
  /**
   * Содержимое ячейки ключа
   */
  "Record.DataCell": {
    "kind": "class",
    "text": "Содержимое ячейки ключа",
    "fields": {
      /**
       * Сектор.
       * # Диапазон: 0..127
       */
      "section": {
        "type": "int32",
        "text": "Сектор.\n# Диапазон: 0..127",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 127,
            "message": "Значение не входит в допустимый диапазон. Максимум: 127"
          },
        }
      },
      /**
       * Блок.
       * # Диапазон: 0..127
       */
      "block": {
        "type": "int32",
        "text": "Блок.\n# Диапазон: 0..127",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 127,
            "message": "Значение не входит в допустимый диапазон. Максимум: 127"
          },
        }
      },
      /**
       * Данные.
       * # Паттерн: /^[A-Za-z0-9=]+$/
       */
      "data": {
        "type": "string",
        "text": "Данные.\n# Паттерн: /^[A-Za-z0-9=]+$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^[A-Za-z0-9=]+$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Za-z0-9=]+$/"
          }
        }
      },
    },
  },
  /**
   * Ошибка сохранения записи.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "Record.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения записи.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Перевод статуса запрещён
       */
      "statusTypeRestricted": {
        "type": "Record.SavingError.StatusTypeRestricted",
        "text": "Перевод статуса запрещён",
      },
      /**
       * Запись уже существует
       */
      "uidExist": {
        "type": "Record.SavingError.UidExist",
        "text": "Запись уже существует",
      },
      /**
       * Вы не владелец
       */
      "ownedByAnotherUser": {
        "type": "Record.SavingError.OwnedByAnotherUser",
        "text": "Вы не владелец",
      },
      /**
       * Ключ уже использован
       */
      "alreadyLinked": {
        "type": "Record.SavingError.AlreadyLinked",
        "text": "Ключ уже использован",
      },
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "Record.SavingError.Conflict",
        "text": "Конфликт версий",
      },
    },
  },
  /**
   * Причины:
   * - Такой ключ уже привязан к другой записи
   */
  "Record.SavingError.AlreadyLinked": {
    "kind": "class",
    "text": "Причины:\n- Такой ключ уже привязан к другой записи",
  },
  /**
   * Причины:
   * - В базе хранится более новая версия записи, значения changed_at отличаются
   */
  "Record.SavingError.Conflict": {
    "kind": "class",
    "text": "Причины:\n- В базе хранится более новая версия записи, значения changed_at отличаются",
  },
  /**
   * Причины:
   * - Запись принадлежит другому пользователю
   */
  "Record.SavingError.OwnedByAnotherUser": {
    "kind": "class",
    "text": "Причины:\n- Запись принадлежит другому пользователю",
  },
  /**
   * Причины:
   * - Недопустимый перевод статуса.
   * - Не переданы обязательные поля https://openapi-key.deploy.rtkit.dev/keyapis_rfidregistry_v1/#таблица-обязательности-передачи-полей-в-request
   */
  "Record.SavingError.StatusTypeRestricted": {
    "kind": "class",
    "text": "Причины:\n- Недопустимый перевод статуса.\n- Не переданы обязательные поля https://openapi-key.deploy.rtkit.dev/keyapis_rfidregistry_v1/#таблица-обязательности-передачи-полей-в-request",
  },
  /**
   * Причины:
   * - Ключ уже существует
   */
  "Record.SavingError.UidExist": {
    "kind": "class",
    "text": "Причины:\n- Ключ уже существует",
  },
  /**
   * Контрольная сумма
   */
  "Record.Trailer": {
    "kind": "class",
    "text": "Контрольная сумма",
    "fields": {
      /**
       * Сектор.
       * # Диапазон: 0..15
       */
      "sector": {
        "type": "int32",
        "text": "Сектор.\n# Диапазон: 0..15",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 15,
            "message": "Значение не входит в допустимый диапазон. Максимум: 15"
          },
        }
      },
      /**
       * Ключ А.
       * # Диапазон: 1..256
       */
      "keyA": {
        "type": "string",
        "text": "Ключ А.\n# Диапазон: 1..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Ключ Б.
       * # Диапазон: 1..256
       */
      "keyB": {
        "type": "string",
        "text": "Ключ Б.\n# Диапазон: 1..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Маска доступа.
       * # Диапазон: 1..512
       */
      "accessMask": {
        "type": "string",
        "text": "Маска доступа.\n# Диапазон: 1..512",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 512,
            "message": "Значение не входит в допустимый диапазон. Максимум: 512"
          },
        }
      },
    },
  },
  /**
   * Фильтр записей
   */
  "RecordFilter": {
    "kind": "class",
    "text": "Фильтр записей",
    "fields": {
      /**
       * По типам ключей
       */
      "rfidTypes": {
        "type": "Record.RfidType",
        "text": "По типам ключей",
      },
      /**
       * По типам шифрования
       */
      "encryptionTypes": {
        "type": "Record.EncryptionType",
        "text": "По типам шифрования",
      },
      /**
       * По номерам ключей
       */
      "uids": {
        "type": "string",
        "text": "По номерам ключей",
      },
      /**
       * По типам статуса
       */
      "statusTypes": {
        "type": "Record.StatusType",
        "text": "По типам статуса",
      },
      /**
       * По номерам привязанных ключей
       */
      "inUseRfidIds": {
        "type": "string",
        "text": "По номерам привязанных ключей",
      },
      /**
       * По владельцам
       */
      "resourceOwnerIds": {
        "type": "string",
        "text": "По владельцам",
      },
      /**
       * По номерам заказа
       */
      "orderNumbers": {
        "type": "string",
        "text": "По номерам заказа",
      },
      /**
       * По владельцам привязанных ключей
       */
      "inUseResourceOwnerIds": {
        "type": "string",
        "text": "По владельцам привязанных ключей",
      },
      /**
       * По удалённым записям.
       * По умолчанию: false
       */
      "isDeleted": {
        "type": "google.protobuf.BoolValue",
        "text": "По удалённым записям.\nПо умолчанию: false",
      },
      /**
       * По тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Номер заказа;
       * # - Производитель
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "По тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Номер заказа;\n# - Производитель",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Дата отгрузки от
       */
      "startShippedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата отгрузки от",
      },
      /**
       * Дата отгрузки до
       */
      "endShippedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата отгрузки до",
      },
      /**
       * По номеру коробки
       */
      "packageInfoBoxes": {
        "type": "int32",
        "text": "По номеру коробки",
      },
      /**
       * По номеру места в коробке
       */
      "packageInfoPlaces": {
        "type": "int32",
        "text": "По номеру места в коробке",
      },
      /**
       * По методу идентификации
       */
      "identificationMethodTypes": {
        "type": "Record.IdentificationMethodType",
        "text": "По методу идентификации",
      },
    },
  },
  /**
   * Пагинация записей
   */
  "RecordPaging": {
    "kind": "class",
    "text": "Пагинация записей",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: NEW_AT
       */
      "orderByType": {
        "type": "RecordPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: NEW_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "RecordPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник типов шифрования ключа.
   */
  "Record.EncryptionType": {
    "kind": "enum",
    "text": "Справочник типов шифрования ключа.",
    "values": {
      /**
       * Значение не указано
       */
      "ENCRYPTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Без шифрования
       */
      "SL0": {
        "i": 1,
        "text": "Без шифрования",
      },
      /**
       * С шифрованием, копируемый
       */
      "SL1": {
        "i": 2,
        "text": "С шифрованием, копируемый",
      },
      /**
       * С шифрованием, не копируемый
       */
      "SL3": {
        "i": 3,
        "text": "С шифрованием, не копируемый",
      },
    },
  },
  /**
   * Справочник методов идентификации.
   */
  "Record.IdentificationMethodType": {
    "kind": "enum",
    "text": "Справочник методов идентификации.",
    "values": {
      /**
       * Значение не указано
       */
      "IDENTIFICATION_METHOD_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Значение Mifare
       */
      "MIFARE": {
        "i": 1,
        "text": "Значение Mifare",
      },
      /**
       * Значение Bluetooth low energy
       */
      "BLE": {
        "i": 2,
        "text": "Значение Bluetooth low energy",
      },
      /**
       * Значение Ultra high frequency
       */
      "UHF": {
        "i": 3,
        "text": "Значение Ultra high frequency",
      },
      /**
       * Значение em-marine
       */
      "EM_MARINE": {
        "i": 4,
        "text": "Значение em-marine",
      },
    },
  },
  /**
   * Справочник типов ключей.
   */
  "Record.RfidType": {
    "kind": "enum",
    "text": "Справочник типов ключей.",
    "values": {
      /**
       * Значение не указано
       */
      "RFID_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Брелок
       */
      "FOB": {
        "i": 1,
        "text": "Брелок",
      },
      /**
       * Карта
       */
      "CARD": {
        "i": 2,
        "text": "Карта",
      },
      /**
       * Браслет
       */
      "BAND": {
        "i": 3,
        "text": "Браслет",
      },
      /**
       * Стикер
       */
      "STICKER": {
        "i": 4,
        "text": "Стикер",
      },
      /**
       * Активная метка
       */
      "ACTIVE_TAG": {
        "i": 5,
        "text": "Активная метка",
      },
    },
  },
  /**
   * Справочник типов статусов ключа.
   */
  "Record.StatusType": {
    "kind": "enum",
    "text": "Справочник типов статусов ключа.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Новый
       */
      "NEW": {
        "i": 1,
        "text": "Новый",
      },
      /**
       * Отгружен
       */
      "SHIPPED": {
        "i": 2,
        "text": "Отгружен",
      },
      /**
       * Брак
       */
      "DEFECT": {
        "i": 3,
        "text": "Брак",
      },
      /**
       * Использован
       */
      "IN_USE": {
        "i": 4,
        "text": "Использован",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "RecordPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "RecordPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По дате перевода в статус new (дате создания)
       */
      "NEW_AT": {
        "i": 1,
        "text": "По дате перевода в статус new (дате создания)",
      },
      /**
       * По времени изменения
       */
      "CHANGED_AT": {
        "i": 2,
        "text": "По времени изменения",
      },
      /**
       * По времени заказа
       */
      "ORDER_AT": {
        "i": 3,
        "text": "По времени заказа",
      },
      /**
       * По номеру заказа
       */
      "ORDER_NUMBER": {
        "i": 4,
        "text": "По номеру заказа",
      },
      /**
       * По рангу для поиска по тексту.
       * Применяется когда передано поле для поиска по тексту.
       * В случае если текстовое поле не передано, применяется значение по умолчанию
       */
      "RANK": {
        "i": 5,
        "text": "По рангу для поиска по тексту.\nПрименяется когда передано поле для поиска по тексту.\nВ случае если текстовое поле не передано, применяется значение по умолчанию",
      },
    },
  },
}